import API from "../axiosConfig";

export const getWorkingPeriods = async () => {
  try {
    const response = await API.get("/working-periods");
    return response.data;
  } catch (error) {
    console.error("Error fetching working periods:", error);
    throw error;
  }
};

export const createWorkingPeriod = async (lineData) => {
  try {
    const response = await API.post("/working-periods", lineData);
    return response.data;
  } catch (error) {
    console.error("Error creating working periods:", error);
    throw error;
  }
};

export const updateWorkingPeriod = async (lineId, lineData) => {
  try {
    const response = await API.put(`/working-periods/${lineId}`, lineData);
    return response.data;
  } catch (error) {
    console.error("Error updating working periods:", error);
    throw error;
  }
};
